// FormHeading.jsx
import React from 'react';
import './FormHeading.css';

const FormHeading = ({ heading, subHeading }) => {
  return (
    <div className='my-3'>
      <h1 className="form-heading">{heading}</h1>
      <p className="form-subheading">{subHeading}</p>
    </div>
  );
};

export default FormHeading;
